import { Component, OnDestroy, OnInit } from '@angular/core';
import { DialogService } from "primeng/dynamicdialog";
import { MessageService } from "primeng/api";
import { EmployeeModel } from "../../models/employees/employee.model";
import { EmployeeRoleEnum } from "../../enums/employee-role.enum";
import { TranslateService } from "@ngx-translate/core";
import { EmployeeService } from "../../services/employees/employe.service";
import { Subject, Subscription, takeUntil } from "rxjs";
import { ManagerEmployeeModel } from '../../models/employees/manager-employee.model';
import { CurrentVenueHelperService } from 'src/app/share-modul/services/current-venue-helper/current-venue.helper.service';
import { ManagerEmployeeService } from '../../services/employees/manager-employees.service';
import { Router } from '@angular/router';
import { CurrentEmployeeHelperService } from 'src/app/share-modul/services/current-employee-order-helper/current-employee-helper.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-manager-employee-orders',
  templateUrl: './manager-employee-orders.component.html',
  styleUrls: ['./manager-employee-orders.component.scss']
})
export class ManagerEmployeeOrdersComponent implements OnInit, OnDestroy {

  public unsubscribe: Subject<void> = new Subject<void>();
  public listAllWaiters: Array<ManagerEmployeeModel> = new Array<ManagerEmployeeModel>();
  public imagePath: string = './assets/images/logo/profile-picture-placeholder.png'
  public EmployeeRoleEnum = EmployeeRoleEnum;
  public spinner: boolean;
  public venueId: string | null;
  public venueIdUpdateSubscription: Subscription;

  constructor(
    public dialogService: DialogService,
    public employeeService: EmployeeService,
    public managerEmployeeService: ManagerEmployeeService,
    private messageService: MessageService,
    public translate: TranslateService,
    public currentVenueHelper: CurrentVenueHelperService,
    public currentEmployeeHelper: CurrentEmployeeHelperService,
    public router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if(params['venue-id'] != null){
        this.venueId = params['venue-id'];
        this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']);
        this.getWaiters(params['venue-id']);    
      }
    });

  }

  getWaiters(venueId: string) {
    this.listAllWaiters = new Array<ManagerEmployeeModel>();
    if (this.venueId) {
      this.managerEmployeeService.listallwaitersforvenue(venueId)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            this.listAllWaiters = response;
          },
          error: errorResponse => {
            this.messageService.add({ severity: 'error', summary: "System error", life: 2000 });
          }
        });
    }
  }

  goToOrders(employee: ManagerEmployeeModel) {
    this.currentEmployeeHelper.updateCurrentEmployee(employee);
    this.router.navigate([this.venueId + `/manager-employee-orders/${employee.id}`])
  }

  determineImageForEmployee(pictureUrl: string) {
    const image = pictureUrl ? pictureUrl : this.imagePath;
    return encodeURI(image);
  }
  ngOnDestroy(): void {
    if (this.venueIdUpdateSubscription) {
      this.venueIdUpdateSubscription.unsubscribe();
    }
  }

}
